import * as React from 'react';
import * as Clients from '../../../client/ApiClient';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Card, CardBody, CardText, CardTitle, Col, Container, Row } from 'reactstrap';
import DataListInput from '../DataListInput';
import { DataCell, DataRow, DataTable, DataTableButton } from '../DataTable';
import * as Roles from 'constants/Roles';
import { store } from '../../../AppContext';
import { enqueueNotification } from '../../../store/Notifications';
import { saveAs } from 'file-saver';
import { CardContent } from '@mui/material';

interface IUIControllerReportPageState {
    userList: Clients.UserModel[] | null;
    selected: string;
    conversionTypes: Clients.ConversionTypeModel[] | null;
}

class UIControllerReportPage extends React.Component<RouteComponentProps, IUIControllerReportPageState>{
    private readonly client: Clients.ConversionClient = new Clients.ConversionClient();
    private readonly users: Clients.UserClient = new Clients.UserClient();
    private conversionTypeClient: Clients.ConversionTypeClient = new Clients.ConversionTypeClient();

    constructor(props: Readonly<RouteComponentProps>) {
        super(props)
        this.state = {
            selected: '',
            userList: null,
            conversionTypes: null,
        }
    }

    componentDidMount() {
        this.showUsers()
        this.getConversionTypes()
    }

    databaseReport = () => {
        this.client.databaseReports()
            .then(response => saveAs(response!.data, response!.fileName))
            .catch(error => {
                console.log(error)
            });
    }

    sendDatabaseReport = () => {
        this.client.sendDatabaseReports()
            .then(() => store.dispatch(enqueueNotification({ type: 'success', message: 'Email Sent' })))
            .catch(error => {
                console.log(error)
                if (error.Diagnostics.Message) {
                    store.dispatch(enqueueNotification({ type: 'error', message: error.Diagnostics.Message }))
                }
                else {
                    store.dispatch(enqueueNotification({ type: 'error', message: 'Email Failed' }))
                }
            });
    }

    showUsers = () => {
        this.users.getAll()
            .then(response => {
                if (response) this.setState({ userList: response })
            })
            .catch(err => console.log(err))
    }

    getConversionTypes = () => {
        this.conversionTypeClient.getAll()
            .then(response => {
                if (response !== null) {
                    if (response.length < 1) throw new Error('Source System Types list should not be empty.');
                    this.setState({
                        conversionTypes: response
                    })
                }
            })
            .catch(error => { });
    }

    handleChange = (e: any) => {
        const value = e.value;
        this.setState({ selected: value },
            () => {
                if (value !== '') {
                    this.editList(value, true)
                }
            })
    }

    editList = (id: string, add: boolean) => {
        this.users.editEmailList(id, add)
            .then(() => this.showUsers())
            .catch(err => console.log(err))
    }

    emailList = (): any[] => {
        const arr = [];
        const userList = this.state.userList && this.state.userList.filter(u => !u.emailList && (u.role!.id === Roles.administrationRoleId || u.role!.id === Roles.developerAdministrationRoleId || u.role!.id === Roles.vertaforeInternalRoleId));
        if (userList) {
            for (const [, user] of userList!.entries()) {
                arr.push(<option
                    key={user.id}
                    data-value={user.id}
                >
                    {`${user.firstName} ${user.lastName}: ${user.emailAddress}`}
                </option>)
            }
        }
        return arr;

    }

    public render() {
        return (
            <>
                <Container>
                    <Row>
                        <Col xs="9">
                            <Card style={{
                                width: '57rem',
                                height: '28rem',
                                margin: '0 10%',
                            }}>
                                <CardBody>
                                    <CardTitle tag="h3">
                                        Database Report
                                    </CardTitle>
                                    <CardText>
                                        <Button
                                            className='load-button'
                                            onClick={() => this.databaseReport()}
                                        > {'Download Database Report'} </Button>
                                    </CardText>
                                    <CardText>
                                        <Button
                                            className='load-button'
                                            onClick={() => this.sendDatabaseReport()}
                                        > {'Send Database Report'} </Button>
                                    </CardText>
                                    <CardContent>
                                        <DataListInput
                                            id={'emailList'}
                                            name={'emailList'}
                                            value={this.state.selected}
                                            onValueChange={event => this.handleChange(event)}
                                            placeholder={'Select Users'}
                                        >
                                            <option data-value='' />
                                            {this.emailList()}
                                        </DataListInput>
                                        <DataTable hover >
                                            <thead>
                                                <tr>
                                                    <th>
                                                        First Name
                                                    </th>
                                                    <th>
                                                        Last Name
                                                    </th>
                                                    <th>
                                                        Email
                                                    </th>
                                                    <th>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="userTable">
                                                {this.state.userList && this.state.userList!
                                                    .filter(u => u.emailList)
                                                    .map(u => {
                                                        return (<DataRow id={u.id!.toString()} key={u!.id}>
                                                            <DataCell>
                                                                {u.firstName}
                                                            </DataCell>
                                                            <DataCell>
                                                                {u.lastName}
                                                            </DataCell>
                                                            <DataCell>
                                                                {u.emailAddress}
                                                            </DataCell>
                                                            <DataCell>
                                                                <DataTableButton
                                                                    icon='close'
                                                                    id={"removeEmailList"}
                                                                    title={"Remove: " + u.firstName + " " + u.lastName}
                                                                    action={() => this.editList(u.id!, false)} />
                                                            </DataCell>
                                                        </DataRow>)
                                                    })}
                                            </tbody>
                                        </DataTable>
                                    </CardContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </Container >
            </>
        )
    }
}

export default withRouter(UIControllerReportPage)